"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetTransformComponents = void 0;
/**
 * @public
 */
function resetTransformComponents(renderer) {
    const transforms = renderer.transformComponents.getAllTransforms();
    for (let i = 0, iEnd = transforms.length; i < iEnd; ++i) {
        transforms[i].resetState();
    }
}
exports.resetTransformComponents = resetTransformComponents;
//# sourceMappingURL=reset-transform-components.js.map